import * as React from "react"
// @ts-ignore
import styles from './Logo.module.scss'

// @ts-ignore
import siteLogo from '../../../../assets/cbs-logo.svg'

const Logo = ({LinkComponent}) => {
  return (
    <div className={styles.Logo}>
      <LinkComponent to="/" className={styles.logoRegular}>
        <img src={siteLogo} alt="CBS logo" />
      </LinkComponent>
    </div>
  )
}

export default Logo
